import css from 'styled-jsx/css';

const styles = css.global`.blog-data-feito-por .ctn {
  display: flex;
  align-items: start;
  margin-bottom: 35px;
  margin-top: 40px;
  flex-direction: column;
  gap: 15px
}

.blog-data-feito-por .ctn div {
  display: flex;
  align-items: center;
}

.blog-data-feito-por p {
  font-family: 'SantanderText';
  font-size: 14px;
  color: #444444;
  margin-left: 15px;
  margin-right: 20px;
}

.blog-data-feito-por img {
  width: 21px;
}

@media (min-width: 768px) {
  .blog-data-feito-por .ctn {
    flex-direction: row;
  }
}`;

export default styles;